export const PUBLIC_API_PAGE = {
  TITLE: 'API',
  DESCRIPTION: "Create and revoke the API keys your integrations use to read and change your organization's data.",
  ENDPOINTS: {
    TITLE: 'Public API endpoints',
    DESCRIPTION: 'Switch each public endpoint on or off for every organization. A disabled endpoint answers 403.',
    SUPERADMINS_ONLY: 'Only superadmins can switch endpoints',
    EMPTY: 'No public endpoints yet',
    TOGGLE: (summary: string) => `Enable ${summary}`,
    UPDATED: 'Endpoint updated',
    COLUMNS: {
      METHOD: 'Method',
      PATH: 'Path',
      SUMMARY: 'Summary',
      ENABLED: 'Enabled',
    },
  },
  API_KEYS: {
    TITLE: 'API keys',
    CREATE: 'Create key',
    EDITORS_ONLY: 'Only editors can manage API keys',
    EMPTY: 'No API keys yet',
    NEVER: 'Never',
    REVOKE: 'Revoke',
    COLUMNS: {
      NAME: 'Name',
      OWNER: 'Owner',
      PREFIX: 'Key',
      CREATED: 'Created',
      EXPIRES: 'Expires',
      LAST_USED: 'Last used',
      STATUS: 'Status',
    },
    STATUS: {
      ACTIVE: 'Active',
      REVOKED: 'Revoked',
      EXPIRED: 'Expired',
    },
    CREATE_DIALOG: {
      TITLE: 'Create API key',
      DESCRIPTION: 'Name it after the integration that uses it',
      NAME: 'Name',
      NAME_PLACEHOLDER: 'CI pipeline',
      SUBMIT: 'Create',
      CANCEL: 'Cancel',
      CREATED_TITLE: 'API key created',
      WARNING: "Copy this key now. You won't see it again",
      COPY: 'Copy key',
      COPIED: 'Key copied',
      DONE: 'Done',
    },
    REVOKE_DIALOG: {
      TITLE: 'Revoke API key',
      DESCRIPTION: (name: string) => `Integrations using ${name} will stop working immediately.`,
      CONFIRM: 'Revoke',
      CANCEL: 'Cancel',
      REVOKED: 'API key revoked',
    },
  },
}
